// SPDX-License-Identifier: AGPL-3.0-or-later

import { useMutation, useQuery } from '@tanstack/react-query';
import { apiFetch, type ApiError } from './client.js';
import type {
  CreateMagicLinkBody,
  CreateMagicLinkResponse,
  MagicLinkChannelsResponse,
} from './types.js';

export const magicLinkChannelsQueryKey = ['magic-link-channels'] as const;

/**
 * What this deployment can actually deliver (intakeform-preview-2a0).
 *
 * The sender is fixed at boot from MAGIC_LINK_SENDER, so the browser cannot
 * know the answer and must not guess it — guessing is what shipped a console
 * default production could not serve, and then an email default that broke
 * every development stack.
 */
export function useMagicLinkChannels() {
  return useQuery<MagicLinkChannelsResponse>({
    queryKey: magicLinkChannelsQueryKey,
    queryFn: () => apiFetch<MagicLinkChannelsResponse>('/api/magic-links/channels'),
    // A deployment-level constant; refetching it per modal open buys nothing.
    staleTime: Infinity,
  });
}

export function useCreateMagicLink() {
  return useMutation<CreateMagicLinkResponse, ApiError, CreateMagicLinkBody>({
    mutationFn: (body) => apiFetch('/api/magic-links', { method: 'POST', body }),
  });
}
